export const locale = {
  GLOBAL: {
    Title: "SMS Land",
    PostalCode: "Postal Code",
    postalCodes: "Postal Codes",
    selectedPostalCodes: "Selected Postal Codes",
    MciNumberCount: "MCI Numbers Count",
    MtuNumberCount: "MTN Numbers Count",
    TotalCount: "Total Count",
    Coefficient: "Coefficient",
    Back: "Back",
  },
  ERRORS: {
    PhoneIsNotValid:
      "The entered phone number is not valid. Example: 09101234567",
    InvalidNumber: "The entered number is not valid",
    NoSelectedLineNumber: "Please select a sender line.",
    EmptyText: "Please enter the text.",
    UnknownError: "Unknown error",
    TryAgain: "Please try again later.",
    NoAccountCharge: "Insufficient balance",
    NoAccess: "You do not have access.",
    PleasebyeAPlane: "Please purchase a plan.",
    PleaseChargeYourAccount: "Please charge your account.",
    AccessDenied: "Access denied.",
    AccessDeniedDescription: "For more information, please contact support",
    Error: "Error",
    InvalidText: "Invalid text",
    InvalidTextContainsLink: "Only service lines can contain links.",
  },
  INFOS: {
    SuccessSentSms: "Message sent successfully",
    SmsRequestInQueue: "Your message will be sent after admin approval",
    SendData: "Sending information",
    CheckData: "Please read and confirm the following information.",
  },
  TOBE: {
    to: "To ",
    from: "From ",
  },
  FORMS: {
    DestinationPhone: "Recipient phone number",
    TestDestinationPhone: "Test phone number",
    SourceNumber: "Sender number",
    Text: "Text",
    CharCount: "Character count",
    FarsiCharCount: "Persian character count",
    EnglishCharCount: "English character count",
    Send: "Send",
    SendTime: "Send time",
    SendTest: "Send test",
    SendToTestNumber: "Send to test number",
    SmsCount: "SMS count",
    SmsLang: "SMS language",
    Add: "Add",
    FromFile: "Add from file",
    TestNumber: "Test number",
    Test: "Test",
    ServiceRelated: "Service-related",
    Price: "Price",
    NumbersCount: "Numbers count",
    NumbersCountToSend: "Number of recipients",
    Search: "Search",
    Title: "Title",
    RequestTime: "Request time",
    RequestInformation: "Request information",
    CreateNewPhoneBook: "Create new phonebook",
  },
  BUTTONS: {
    OK: "OK",
    AccountCharge: "Charge account",
    Reports: "Reports",
    RemoveAll: "Remove all",
    BuyAPlane: "Buy plan",
    Accept: "Accept",
    Reject: "Reject",
    Yes: "Yes",
    No: "No",
    Create: "Create",
    New: "New",
    Save: "Save",
    Delete: "Delete",
    More: "More",
    TryAgain: "Try again",
    Close: "Close",
    RollBack: {
      back: "Back to previous user",
      goToMainUser: "Back to main user",
      CurrentUser: "Current user",
    },
  },
  DIALOGS: {
    Waiting: "Please wait",
    RejectItQuestion: "Reject it?",
    AcceptItQuestion: "Accept it?",
    Rejected: "Rejected",
    Accepted: "Accepted",
    Error: "Error",
  },
  CONFIRM: {
    Delete: "Are you sure you want to delete?",
    DeleteA: "Are you sure you want to delete {a}?",
    DeleteALL: "Are you sure you want to delete all?",
  },
  LANGUAGE: {
    English: "English",
    Persian: "Persian",
  },
  language: {
    selectAll: "Select All",
    lang: {
      fa: "Persian",
      ar: "Arabic",
      ar_ae: "Arabic (UAE)",
      ar_iq: "Arabic (Iraq)",
      en_US: "English (USA)",
      en_GB: "English (UK)",
      de: "German",
      fr: "French",
      zh_CN: "Simplified Chinese",
      zh_TW: "Traditional Chinese",
      tr: "Turkish",
      ru: "Russian",
      hy: "Armenian",
    },
    only_manual_now: "Only manual translation is available right now",
    ai_coming_soon: "AI translation coming soon",
    got_it: "Got it",
    origin_language: "Source Language",
    target_languages: "Target Languages",
    remove_all: "Remove All Languages",
    translation_method: "Select Translation Method",
    manual_translation: "Manual Translation",
    ai_translation: "AI Translation",
    coming_soon: "Coming Soon",
    source_language_updated: "Source language updated",
    error_changing_source_language: "Error updating source language",
    source_language_created: "New source language created",
    languages_saved: "Languages saved",
    error_saving_languages: "Error saving languages",
    error_loading_language: "Error loading language",
    languages_removed: "Languages removed",
    new_languages_to_save: "New languages to save",
    saved: "Saved",
    management_langs: "Language Management",
    add_langs: "Add Language",
    change_language: "Change Language",
    visit_card: "Business Card",
    translate_to: "Translate to",
    main_language: "Language",
    no_languages_available: "No languages available",
    return_to_default: "Back to Default Language",
    translate: "Translate",
    apply_changes: "Applying changes…",
    changes_pending: "changes_pending",
    cancel_changes: "Cancel",
  },

  LISTS: {
    NoData: "No data available",
    NoDataFound: "No data found",
    NoDataFoundFor: "No data found for {a}",
    NoPhoneNumber: "No phone number found",
    NoPostalCode: "No postal code found",
    AddANumber: "Add a number",
    City: "City",
    AddedBefore: "Already added",
  },
  PAGES: {
    SendSms: "Send SMS",
    MapSms: "Send by map",
    PhoneBook: "Phonebook",
  },
  MONETARY: {
    Rial: "Rial",
  },
  HINTS: {
    SendMessageTitle:
      "Title is an optional name you can use to reuse previous messages. The title will not be sent in the SMS. It is used for reporting and message suggestions.",
    SendMessageTime:
      "Send time is when your SMS will be queued for sending. Note that if not approved by the admin, the SMS will not be sent.",
    CreatePhoneBook:
      "When sending SMS, this name will be used when adding numbers.",
  },
  TOASTS: {
    SuccessCreate: "Created successfully",
    FailedCreated: "Failed to create",
    SuccessDelete: "Deleted successfully",
    FailedDelete: "Failed to delete",
    SuccessEdit: "Edited successfully",
    FailedEdit: "Failed to edit",
    AddedSuccess: "Added successfully",
    AddedFailed: "Failed to add",
  },
  WALLET: {
    CustomCharge: "Custom amount",
    GateWay: "Payment gateway",
    Price: "Amount",
    Details: [
      "9% tax will be added to the entered amount.",
      "Please enter the amount carefully. Deposited funds are non-refundable.",
    ],
    noGateWay: "No gateway has been defined for you.",
    PriceNotInRange: "The amount must be between {min} Rial and {max} Rial.",
    Pay: "Pay",
    ErrorOnRedirectToGateWay: "Error redirecting to payment gateway",
    ChargeWalletButtonDescription: "Click the + button to charge your account",
  },
  login: {
    phoneField: {
      placeholderIran: "Start with 9 (example: +98 912 345 6789)",
      placeholderDefault: "Enter your phone number",
      maxDigitsError: "Maximum {count} digits allowed!",
      iranMustStartWith9: "Mobile number must start with 9 (like 912...)",
    },
    signup_button: "I will register!",
    forget_password_title: "Forgot Password",
    register_title: "Free Registration",
    login_title: "Login",
    back: "Back",
    username_label: "Phone number / Username",
    otp_resend_button: "Resend Code",
    password_label: "Password",
    password_hint: "Minimum 8 characters",
    name_label: "First Name",
    name_rule: "Minimum 3 characters",
    lastname_label: "Last Name",
    phone_label: "Mobile Phone",
    nid_label: "National ID",
    parent_phone_label: "Referral's Mobile Phone (Optional)",
    terms_and_conditions_message:
      "By registering, you agree to the terms and conditions of Terminal Ads.",
    terms_and_conditions_link: "Terms and Conditions",
    close: "Close",
    forgot_password_link: "Did you forget your password?",
    change_password: "Change Password",
    register_button: "Register",
    login_button: "Login",
    login_with_google: "Login with Google",
    login_with_sms: "Login with SMS",
    login_with_password: "Login with Password",
    already_registered: "Already registered?",
    login_here: "Login here",
    no_account: "Don't have an account?",
    signup_now: "Register now!",
    more_info: "More Information",
    text_login: "Login",
    text_register: "Register",
    required_field: "This field is required.",
    min_8_char: "Your input is less than 8 characters",
    required: "This field is mandatory",
    min_3_char: "Minimum 3 characters",
    max_50_char: "Maximum 50 characters",
    no_internet: "You are not connected to the internet",
    no_phone_entered: "You have not entered a phone number",
    otp_sent_successfully: "Verification code sent successfully.",
    please_register_first: "Please register first!",
    wait_3_min: "Please wait 3 minutes before trying again.",
    login_successful: "Login successful",
    internet_connection_error: "Internet connection error!",
    agree_to_terms_error: "You have not agreed to the terms and conditions!",
    otp_sent_successfully_register: "Verification code sent successfully.",
    error: "Error",
    registration_nid_required_notice:
      "To ensure high security services and to prevent any fraud (phishing) or misuse of the system, entering the National ID in Terminal Ads is mandatory for registration.",
  },
  home: {
    title: "Home",
    selectSystem: "Select System",
    yourPoints: "Your Points",
    discountCodes: "Discount Codes",
    all: "All",
    discounts: "Discounts",
    systemGuide: "System Guide",
    yourPointsDynamic: "Your Points: {points}",
    confirm: "Confirm",
    copy: "Copy",
  },

  badges: {
    free: "Free",
    preRegister: "Pre-Registration",
    comingSoon: "Coming Soon",
    testVersion: "Test Version",
  },
  services: {
    qrLand: {
      title: "QR Land System",
      description: "Create Dynamic QR Codes",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    payamak: {
      title: "Payamak Land System",
      description: "Send Bulk Promotional SMS",
      property: {
        0: "Send bulk SMS",
        1: "Includes an updated phone number database",
        2: "Send SMS to customer clubs",
        3: "Ability to connect to all websites and software",
      },
    },
    robot: {
      title: "Robot Land System",
      description: "Simultaneous management of all numbers, ads, and panels",
      property: {
        0: "Bulk and group ad registration",
        1: "Timed, gradual, and smart ad management",
        2: "Rent and add unlimited numbers for ad registration",
        3: "Register and manage all ads simultaneously",
      },
    },
    infoLand: {
      title: "Info Land",
      description: "Over 2500 updated business databases",
      property: {
        0: "Contains all industry information",
        1: "Categorization of all cities and provinces",
        2: "Database of all national industries",
        3: "Ability to review samples of all databases",
      },
    },
    graphic: {
      title: "Graphic Land System",
      description: "Complete graphic and video design solutions",
      property: {
        0: "Logo and stationery design",
        1: "All printing and packaging services",
        2: "Catalog, brochure, and box design",
        3: "Design and printing of banners in various sizes",
      },
    },
    bestWebLand: {
      title: "Best Web Land System",
      description: "Website design, support, and SEO",
      property: {
        0: "Content SEO",
        1: "Off-page SEO",
        2: "Technical SEO",
        3: "On-page SEO",
      },
    },
    onlineShop: {
      title: "Online Website Builder System",
      description: "Just a few clicks away from the digital world",
      badge: "Sales Partnership",
      property: {
        0: "Content SEO",
        1: "Off-page SEO",
        2: "Technical SEO",
        3: "On-page SEO",
      },
    },
    social: {
      title: "Social Media Advertising",
      description: "Review and select the best pages and channels",
      property: {
        0: "Review all high-traffic pages",
        1: "Unified management of all covered advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Online ordering of ads on preferred pages",
      },
    },
    billboard: {
      title: "Online Billboard Rental",
      description: "Targeted billboard review without intermediaries",
      property: {
        0: "Review the location and type of billboard",
        1: "Manage all covered billboards",
        2: "Direct communication with billboard owners without intermediaries",
        3: "No need to pay commissions or additional costs",
      },
    },
    internationalMedia: {
      title: "National Media Advertising",
      description: "Review and place advertisements on TV and radio",
      property: {
        0: "Review and select advertisement airing times",
        1: "Review and select types of TV advertisements",
        2: "Review and select types of radio advertisements",
        3: "Review and select advertisements for specific TV programs",
      },
    },
    transport: {
      title: "Transportation Advertising",
      description: "Airports, train stations, buses, and metro",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of metro advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in the metro",
      },
    },
    cinema: {
      title: "Visual Media Advertising",
      description:
        "Place advertisements in cinemas and video-sharing platforms",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    estate: {
      title: "Online Real Estate System",
      description: "Manage files, consultants, and clients",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    AIGeneration: {
      title: "AI System",
      description: "Image generation and chatbot",
    },
    ShortLink: {
      title: "Short Link System",
      description: "Create short links",
    },
    customer: {
      title: "Online Customer Management System",
      description: "Management, support, and creation of loyal customers",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    internetBroadcasting: {
      title: "Online Advertising Management",
      description: "Google Ads, click-based ads, and sponsored articles",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    emailMarketing: {
      title: "Email Marketing System",
      description: "Send promotional emails to all businesses nationwide",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    adsOnStudium: {
      title: "Advertising in Stadiums and Exhibitions",
      description: "Showcase your brand in major centers",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    bidOnline: {
      title: "Comprehensive Online Auction System",
      description: "Conduct and participate in online auctions",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    onlineTools: {
      title: "Online Business Tools System",
      description: "All auxiliary tools for any type of business",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    onlineLearn: {
      title: "Online Business Training System",
      description: "Targeted review and selection of training programs",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    cloud: {
      title: "Hosting and Domain Purchase",
      description: "Purchase hosting, domains, and servers",
      property: {
        0: "Review and select the type and location of advertisements",
        1: "Review and select types of cinema advertisements",
        2: "No need to pay commissions or additional costs",
        3: "Unified management of all advertisements placed in cinemas",
      },
    },
    QrlandShop: {
  title: "Online Store Management",
  description: "Integrated management of products, marketplaces, and smart pricing",
  property: {
    0: "Comprehensive product monitoring and management",
    1: "Product variant management",
    2: "Marketplace monitoring and management",
    3: "Smart pricing strategies",
  },
},

  },
  "planning.title": "Planning",
  "tabs.reminder": "Reminder",
  "tabs.notes": "Notes",
  "tabs.calendar": "Calendar",
  "notes.creationDate": "Creation Date",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "actions.quickActions": "Quick Actions",
  "notes.writeMessage": "Write Message",
  "notes.titlePlaceholder": "Note Title",
  "notes.addNote": "Add Note",
  "notes.updatedSuccess": "Note updated successfully.",
  "notes.addedSuccess": "Note added successfully.",
  "common.deletedSuccess": "Deleted successfully",
  "common.confirmDelete": "Are you sure you want to delete?",
  "news.title": "Site News",
  "news.noNews": "No news has been registered on the site.",
  "news.view": "View",
  "remember.add": "Create Reminder",
  "remember.update": "Update Reminder",
  "remember.titleLabel": "Title",
  "remember.dateLabel": "Reminder Date",
  "remember.confirmDelete": "Are you sure you want to delete?",
  "remember.deleteSuccess": "Reminder deleted successfully.",
  "remember.createSuccess": "New reminder created.",
  "remember.updateSuccess": "Reminder updated.",
  "points.receivedAwards": "Received Awards",
  "points.pointsHistory": "Points History",
  "points.points": "points",
  "points.discountTitle": "Robot Land Discount",
  "points.discountText": "For every 500 points",
  events: {
    title: "Events",
    addEvent: "Add Event",
    calendar: "Base Calendar",
    close: "Close",
    save: "Save",
    update: "Update",
    confirmDelete: "Are you sure you want to delete?",
    successAdd: "Successfully added.",
    successDelete: "Event successfully deleted.",
    successUpdate: "Update was successful.",
    titleLabel: "Title",
    descriptionLabel: "Description",
    colorLabel: "Color",
    removeAfterDrop: "remove After Drop",
    createEvent: "Create Event",
  },
  copySuccess: "Copied successfully.",
  copyTextTitle: "Copy",
  copiedTextTitle: "Copied",
  copySuccess: "Copied successfully.", // For CopyButton.vue
  ribbon: {
    new: "NEW",
  },
  coupons: [
    {
      text: "This coupon is valid for 3 weeks.",
      title: "Non-repetitive text 20%",
    },
    {
      text: "This coupon is valid for 2 weeks.",
      title: "Website design 5%",
    },
    {
      text: "This coupon can only be used once.",
      title: "Page management 10%",
    },
    {
      text: "This coupon is permanently activated for you.",
      title: "Graphic design 5%",
    },
    {
      text: "This coupon can only be used once.",
      title: "Printing 2%",
    },
  ],
  userLinks: {
    profile: {
      title: "Overview",
      invitation: { title: "Invite Friends" },
      info: { title: "Personal Information" },
      edit: { title: "Edit Profile" },
      changePass: { title: "Change Password" },
    },
  },
  profileLinks: {
    orders: "Orders",
    addresses: "Addresses",
  },
  customPage: {
    overview: "Overview",
    personalInfo: "Personal Information",
    changePassword: "Change Password",
    completeProfile: "Complete Profile",
    email: "Email",
    balance: "Balance",
    phone: "Phone Number",
    rial: "Rial",
  },
  widget12: {
    inviteFriends: "Invite Friends",
    viewInvitedUsers: "View the list of users invited by you",
    yourInviteCode: "Your Invite Code",
    createNewUser: "Create New User",
    copyText: "Copy",
    userCreatedSuccess: "New user created successfully",
    notCreated: "Not Created",
  },
  userInfo: {
    userInformation: "User Information",
    profilePicture: "Profile Picture",
    allowedFileTypes: "Allowed file types: png, jpg, jpeg.",
    profilePictureSize:
      "Profile picture must have equal dimensions (e.g., 480 × 480).",
    firstName: "First Name",
    lastName: "Last Name",
    username: "Username",
    phone: "Phone Number",
    email: "Email",
    receiveSMS: "Receive SMS",
    smsCostNote:
      "Enabling this option will deduct SMS costs from your account.",
    saveChanges: "Save Changes",
    profileUpdated: "Your profile has been successfully updated.",
  },
  emailSettings: {
    completeProfile: "Complete Profile",
    completeProfileDesc: "Complete personal or organization information",
    cancel: "Cancel",
    update: "Update",
    save: "Save",
    selectPersonType: "Please select the person type?",
    realPerson: "Individual",
    legalPerson: "Legal Entity",
    phone: "Mobile Number",
    landline: "Landline Number",
    fatherName: "Father’s Name",
    nationalCode: "National Code",
    idNumber: "ID Number",
    birthday: "Date of Birth",
    placeOfBirth: "Place of Birth",
    postalCode: "Postal Code",
    email: "Email",
    introduction: "How Did You Hear About Us",
    nationalCodePic: "National ID Photo",
    plaque: "Plaque",
    address: "Full Address",
    companyName: "Company/Store Name",
    registrationNumber: "Registration Number",
    economicCode: "Economic Code",
    organizationIdentity: "Organization National ID",
    companyType: "Company Type",
    activity: "Field of Activity",
    registrationAd: "Company Registration Ad Image",
    lastPublishedAd: "Latest Published Official Ad Image",
    statute: "Company Statute Image",
    agentLetterPic: "Company Representative Letter Image",
    successMessage: "Successfully registered",
    errorSelectType: "Please select one option.",
    rules: {
      companyName: "Company or store name is required.",
      registrationNumber: "Registration number is required.",
      economicCode: "Economic code is required.",
      organizationIdentity: "Organization national ID is required.",
      registrationAd: "Company registration ad image is required.",
      lastPublishedAd: "Latest published official ad image is required.",
      telephone: "Landline number is required.",
      fatherName: "Father’s name is required.",
      nationalCode: "National code is required.",
      birthday: "Date of birth is required.",
      idNumber: "ID number is required.",
      placeOfBirth: "Place of birth is required.",
      postalCode: "Postal code is required.",
      nationalCodePic: "National ID photo is required.",
      address: "Address is required.",
      plaque: "Plaque is required.",
    },
    companyTypes: {
      governmental: "Governmental",
      private: "Private",
      commonStock: "Public Stock",
      specialStock: "Private Stock",
    },
  },
  emailSettings: {
    completeProfile: "Complete Profile",
    completeProfileDesc: "Complete personal or organization information",
    cancel: "Cancel",
    update: "Update",
    save: "Save",
    selectPersonType: "Please select the person type?",
    realPerson: "Individual",
    legalPerson: "Legal Entity",
    phone: "Mobile Number",
    landline: "Landline Number",
    fatherName: "Father’s Name",
    nationalCode: "National Code",
    idNumber: "ID Number",
    birthday: "Date of Birth",
    placeOfBirth: "Place of Birth",
    postalCode: "Postal Code",
    email: "Email",
    introduction: "How Did You Hear About Us",
    nationalCodePic: "National ID Photo",
    plaque: "Plaque",
    address: "Full Address",
    companyName: "Company/Store Name",
    registrationNumber: "Registration Number",
    economicCode: "Economic Code",
    organizationIdentity: "Organization National ID",
    companyType: "Company Type",
    activity: "Field of Activity",
    registrationAd: "Company Registration Ad Image",
    lastPublishedAd: "Latest Published Official Ad Image",
    statute: "Company Statute Image",
    agentLetterPic: "Company Representative Letter Image",
    successMessage: "Successfully registered",
    errorSelectType: "Please select one option.",
    rules: {
      companyName: "Company or store name is required.",
      registrationNumber: "Registration number is required.",
      economicCode: "Economic code is required.",
      organizationIdentity: "Organization national ID is required.",
      registrationAd: "Company registration ad image is required.",
      lastPublishedAd: "Latest published official ad image is required.",
      telephone: "Landline number is required.",
      fatherName: "Father’s name is required.",
      nationalCode: "National code is required.",
      birthday: "Date of birth is required.",
      idNumber: "ID number is required.",
      placeOfBirth: "Place of birth is required.",
      postalCode: "Postal code is required.",
      nationalCodePic: "National ID photo is required.",
      address: "Address is required.",
      plaque: "Plaque is required.",
    },
    companyTypes: {
      governmental: "Governmental",
      private: "Private",
      commonStock: "Public Stock",
      specialStock: "Private Stock",
    },
  },
  changePassword: {
    title: "Change Password",
    description: "Change your account password",
    cancel: "Cancel",
    update: "Update",
    passwordInstructions: {
      forgotPassword:
        "If you haven’t set a password yet, you can click on the forgot password option.",
      passwordRequirements:
        "The password must be 8 characters long, including numbers, uppercase and lowercase English letters, and symbols.",
      passwordPrivacy: "Please do not share your password with others.",
      keyboardLanguage:
        "Ensure your keyboard is set to English when setting the password.",
    },
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    addOrForgotPassword: "Add or Forgot Password",
    changePasswordWithCode: "Change Password with Code",
    close: "Close",
    change: "Change",
    enterCode: "Enter Code",
    successMessage: "Password updated successfully",
    invalidCode: "The provided code is incorrect.",
    tooManyAttempts: "Too many attempts!",
    rules: {
      required: "This field is required.",
      min: "The field must be at least 8 characters long.",
      equal: "The password and confirm password fields do not match.",
      number: "Enter a valid number of digits.",
    },
  },
  router: {
    dashboard: "Dashboard",
    contacts: "Customer Club",
    editContact: "Edit Customer",
    createContact: "Create Customer",
    customers: "Customer List",
    contactList: "Contact Assistant",
    messages: "Messages",
    messageCategories: "Message Categories",
    oldTransactions: "Old Transactions",
    yourTransactions: "Your Transactions",
    buyPanel: "Buy Panel",
    permissions: "Permissions",
    createPermission: "Create Permission",
    invitations: "My Invitations",
    editUser: "Edit User",
    userInformation: "View User Information",
    walletEdit: "Edit User Wallet Information",
    userHistory: "User History",
    userNotificationsHistory: "User Notifications History",
    notifications: "Notifications",
    createNotification: "Create Notification",
    editNotification: "Edit Notification",
    adminNotifications: "Admin Notifications",
    yourNotifications: "Your Notifications",
    adminNotificationsList: "Admin Notifications",
    tickets: "Tickets",
    createTicket: "Create New Ticket",
    editTicket: "Edit Ticket",
    departments: "Departments",
    createDepartment: "New Department",
    editDepartment: "Edit Department",
    adminTickets: "Manage Tickets",
    discounts: "Discounts",
    createDiscount: "Create Discount",
    editDiscount: "Edit Discount",
    workReports: "Work Reports",
    createWorkReport: "Create Work Report",
    callMonitoring: "Call Monitoring",
    adminWorkReports: "Manage Work Reports",
    editWorkReport: "View and Edit Work Report",
    packProperties: "Package Features",
    createPackProperty: "Create Package Feature",
    editPackProperty: "Edit Package Feature",
    panels: "Panels",
    createPanel: "Create Panel",
    editPanel: "Edit Panel",
    transferRequests: "Withdrawal Requests",
    editTransferRequest: "Edit Withdrawal Request",
    tariffs: "Tariffs",
    createTariff: "Create Tariff",
    editTariff: "Edit Tariff",
    requests: "Requests",
    viewUser: "View User",
    manageTransactions: "Manage Transactions",
    viewTransaction: "View Transaction",
    manageConfigs: "Manage Settings",
    rbLandConfigs: "Manage Robot Land Settings",
    editConfig: "Edit Settings",
    manageUsers: "Manage Users",
    categories: "Categories",
    createCategory: "Add Category",
    editCategory: "Edit Category",
    content: "Content",
    createContent: "Create Content",
    editContent: "Edit Content",
    addUserGuide: "Add User Guide",
    editUserGuide: "Edit User Guide",
    roles: "Roles",
    editRole: "Edit Role",
    createRole: "Add Role",
    permissionTitle: "Permissions", // For cruds.permission.title
    paymentGateways: "Payment Gateways",
    editPaymentGateway: "Edit Payment Gateway",
    campaigns: "Campaigns",
    createCampaign: "Create Campaign",
    editCampaign: "Edit Campaign",
    adminCustomers: "Customers",
    createCustomer: "Create Customer",
    editCustomerInfo: "Edit Customer Information",
    referrerCustomers: "Referrer Customers",
    customerHistory: "Customer History",
    userProfile: "User Profile",
    editProfile: "Edit Profile",
    inviteFriends: "Invite Friends",
    personalInfo: "Personal Information",
    editPersonalInfo: "Edit Information",
    changePassword: "Change Password",
    newWallet: "New Wallet",
  },
  profileView: {
    email: "Email",
    balance: "Balance",
    personType: "Person Type",
    currency: "Rial",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "You have the {title} panel, which lasts for {days} days.",
    buyOrRenew: "Click the button below to purchase or renew your panel.",
    buyPanel: "Buy Panel",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "Profile Settings",
    changePasswordTitle: "Change Login Password",
    changePasswordSubtitle: "Change your account login password.",
    alertMessage:
      "If you have not set a password yet, enable the set password option.",
    currentPasswordLabel: "Current Password",
    setPasswordLabel: "Set Password",
    addPassword: "Add Password",
    newPasswordLabel: "New Password",
    repeatPasswordLabel: "Repeat Password",
    saveChanges: "Save Changes",
    currentPasswordPlaceholder: "Current Password",
    newPasswordPlaceholder: "New Password",
    repeatPasswordPlaceholder: "Repeat Password",
  },
  profileOrders: {
    cardTitle: "Orders",
    openOrders: "Open Orders ({count})",
    closedOrders: "Closed Orders ({count})",
    noOrders: "You haven’t placed any orders with us yet.",
  },
  personalInformation: {
    cardTitle: "Personal Account Information",
    cardSubtitle: "Update your personal information.",
    cancel: "Cancel",
    update: "Update",
    yourInfo: "Your Information",
    profilePicture: "Profile Picture",
    allowedFileTypes: "Allowed file types: png, jpg, jpeg.",
    pictureSize:
      "Profile picture must have equal dimensions (e.g., 480 × 480).",
    name: "Name",
    lastName: "Last Name",
    username: "Username",
    receiveSMS: "Receive SMS",
    smsCostNote:
      "By enabling this option, the cost of sending SMS will be deducted from your account.",
    phoneNumber: "Phone Number",
    phonePlaceholder: "Phone Number",
    email: "Email",
    emailPlaceholder: "Email",
    emailPrivacy: "We never share your email with others.",
    successMessage: "Your profile has been successfully updated.",
  },
  personalInformation: {
    cardTitle: "Personal Account Information",
    cardSubtitle: "Update your personal information.",
    cancel: "Cancel",
    update: "Update",
    yourInfo: "Your Information",
    profilePicture: "Profile Picture",
    allowedFileTypes: "Allowed file types: png, jpg, jpeg.",
    pictureSize:
      "Profile picture must have equal dimensions (e.g., 480 × 480).",
    name: "Name",
    lastName: "Last Name",
    username: "Username",
    receiveSMS: "Receive SMS",
    smsCostNote:
      "By enabling this option, the cost of sending SMS will be deducted from your account.",
    phoneNumber: "Phone Number",
    phonePlaceholder: "Phone Number",
    email: "Email",
    emailPlaceholder: "Email",
    emailPrivacy: "We never share your email with others.",
    successMessage: "Your profile has been successfully updated.",
  },
  userInfoForm: {
    companyName: "Company/Store Name",
    registrationNumber: "Registration Number",
    economicCode: "Economic Code",
    organizationIdentity: "Organizational National ID",
    companyType: "Company Type",
    activity: "Field of Activity",
    registrationAd: "Company Registration Document",
    lastPublishedAd: "Latest Published Official Document",
    statute: "Company Statute",
    argentLetterPic: "Company Representative Letter",
    phone: "Mobile Number",
    telephone: "Landline Number",
    fatherName: "Father’s Name",
    nationalCode: "National ID",
    id: "ID Number",
    birthday: "Date of Birth",
    placeBirthday: "Place of Birth",
    postalCode: "Postal Code",
    email: "Email",
    introduction: "How Did You Hear About Us",
    nationalCodePic: "National ID Photo",
    plaque: "Plaque Number",
    address: "Full Address",
    companyTypes: {
      governmental: "Governmental",
      private: "Private",
      common_stock: "Public Stock",
      special_stock: "Private Stock",
    },
    rules: {
      companyName: "The company or store name field is required.",
      registration_number: "The registration number field is required.",
      economic_code: "The economic code field is required.",
      organization_identity:
        "The organizational national ID field is required.",
      registration_ad: "The company registration document field is required.",
      last_published_ad:
        "The latest published official document field is required.",
      telephone: "The landline number field is required.",
      fatherName: "The father’s name field is required.",
      nationalCode: "The national ID field is required.",
      id: "The ID number field is required.",
      birthday: "The date of birth field is required.",
      placeBirthday: "The place of birth field is required.",
      postalCode: "The postal code field is required.",
      nationalCodePic: "The national ID photo field is required.",
      address: "The address field is required.",
      plaque: "The plaque number field is required.",
    },
  },
  createUserForm: {
    name: "Name",
    lastName: "Last Name",
    nid: "National ID",
    phone: "Mobile Number",
    create: "Create",
    errors: {
      nameRequired: "Name is required!",
      lastNameRequired: "Last name is required!",
      nidRequired: "National ID is required!",
      phoneRequired: "Mobile number is required!",
    },
  },
  lastView: {
    cardTitle: "Your Recent Visits",
    cardSubtitle: "Your latest visits to our pages",
    tableHeaders: {
      page: "Page",
      address: "Address",
      enterDate: "Entry Date",
      leaveDate: "Exit Date",
      timeSpent: "Time Spent on Page",
    },
    viewAll: "View All",
    timeUnit: "minutes",
    pages: {
      home: "Home",
      panels: "Panels",
      profile: "Profile Completion",
    },
  },
walletWidget: {
  title: "Recent Transactions",
  balanceLabel: "Your Balance:",
  viewTransactions: "View Transactions",
  transactionTypes: {
    withdraw: "Withdraw",
    deposit: "Deposit",
    charge: "Wallet Top-up",
    refund: "Refund",
    default: "Transaction",
    adminCharge: "Admin Adjustment",
    agency: "Agency Commission",
  },
},
  panelWidget: {
    title: "You have the {title} panel, which lasts for {days} days.",
    renewPrompt: "Click the button below to purchase or renew your panel.",
    buyPanel: "Purchase Panel",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} days",
  },
  component: {
    title: "Users Invited by You",
    columns: {
      row: "Row",
      name: "First Name",
      family: "Last Name",
      username: "Username",
      phone: "Phone Number",
      created_at: "Registration Date",
      actions: "Actions",
    },
    unknown: "Unknown",
    error: "Error",
    breadcrumb: "Invited Users",
  },
  table: {
    itemsPerPage: "Rows per page",
    pageText: "Showing {0} to {1} of {2} entries",
    prevText: "Previous",
    nextText: "Next",
    noDataText: "No data available",
    search: "Search",
  },
  UserHistory: {
    title: "User History",
    add_history: "Add New History",
    send_message: "Send Message",
    close: "Close",
    save: "Save",
    cancel: "Cancel",
    new_history_dialog_title: "Add New History",
    send_message_dialog_title: "Send Message",
    negotiations: "Negotiations Conducted",
    follow_up: "Follow-Up for Next Contact",
    success_history: "History added successfully.",
    success_message: "Message sent successfully.",
    columns: {
      id: "ID",
      title: "Title",
      status: "Status",
      current_time_date: "Last Contact Date",
      current_time_hour: "Last Contact Time",
      next_time_date: "Next Contact Date",
      next_time_hour: "Next Contact Time",
      user_id: "Support",
      actions: "Actions",
    },
    table: {
      itemsPerPage: "Rows per page",
      pageText: "Showing {0} to {1} of {2} entries",
      prevText: "Previous",
      nextText: "Next",
      noDataText: "No data available",
      search: "Search",
    },
    form: {
      title: "Title",
      status: "Status",
      current_time: "Last Contact Date",
      description: "Description",
      next_time: "Next Contact Date",
      pursue_text: "Follow-Up Text",
      category: "Select Category",
      message_title: "Message Title",
    },
  },
  newUserTransactions: {
    userWallet: "User Wallet",
    transactionList: "Transaction List",
    userTransactions: "User Transactions",
    terminal: "Terminal",
    liveSms: "Live SMS",
    realEstateNews: "Real Estate News",
    rial: "Rial",
    row: "Row",
    uniqueId: "ID",
    amount: "Amount",
    time: "Time",
    createdAt: "Date",
    description: "Additional Details",
    type: "Transaction Type",
    product_description: "Description",
    serviceId: "Service Name",
    balanceAfter: "Remaining Balance",
    perPage: "Items per page",
    search: "Search",
    balance: "Balance",
    transactionListTooltip: "Transaction List",
    panelLogin: "Panel Login",
    history: "History",
    error: {
      terminalWallet: "Error retrieving terminal wallet",
    },
    row: "Row",
    uniqueId: "ID",
    amount: "Amount",
    time: "Time",
    createdAt: "Date",
    description: "Additional Details",
    type: "Transaction Type",
    product_description: "Description",
    serviceId: "Service Name",
    balanceAfter: "Remaining Balance",
    search: "Search",
    perPage: "Items per page",
    transactionType: "Transaction Type",
    service: "Service",
    dateFrom: "Date From",
    dateTo: "Date To",
    oldWallet: "Old Wallet",
    depositReceipt: "Deposit Receipt",
    showReceipt: "Show Receipt",
    transactionTypes: {
      online: "Online",
      admin: "By Admin",
      refund: "Refund Transaction",
      agency: "Agency",
      withdraw: "Withdrawal",
      deposit: "Deposit",
    },
    error: {
      imageLoad: "Error loading image!",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "Please choose the panel type carefully!",
    },
    dialog: {
      title: "Purchase Panel",
      confirmPurchase: "Are you sure you want to purchase the {title} panel?",
      discountCodeLabel: "Discount Code",
      discountCodePlaceholder: "Enter your discount code",
      applyDiscount: "Apply Code",
      purchase: "Purchase",
      iHaveDiscount: "I have a discount code",
    },
    toast: {
      discountApplied: "Your discount code was applied successfully!",
      purchaseSuccess: "The package was purchased successfully",
      error: "An error occurred: {message}",
      unauthorized: "Please log in first",
      validationError: "Validation error: {message}",
    },
    currency: "Rial",
  },
  panelCard: {
    rial: "Rial",
    days: "Days",
    buyPanel: "Buy Panel",
  },
  cons: {
    title: "Select Emoji",
  },
  cons1: {
    title: "Default Text",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "Large Advertising Terminal System",
  },
};
